import { useQuery } from "@apollo/client";
import _ from "lodash";
import { Link } from "react-router-dom";
import { Article, ArticleSource } from "../../api/schema";
import { Spinner } from "../../components/Spinner";
import { Table, TableColumns } from "../../components/Table";
import { UserLanguage } from "../../lang/lang";
import {
  GroupPrettyRender,
  LocationPrettyRender,
} from "../../utils/PrettyRenderer";
import { FullArticleQuery } from "./graphql";

export const ArticleSourceListColumns: TableColumns<ArticleSource> = {
  order_number: {
    label: UserLanguage().data.articleSource.order_number,
    render: (item) => {
      if (item.url) {
        return (
          <a href={item.url} target="_blank" rel="noreferrer">
            {item.order_number}
          </a>
        );
      } else if (item.distributor.search_url) {
        return (
          <a
            href={item.distributor.search_url.replace("%s", item.order_number)}
            target="_blank"
            rel="noreferrer"
          >
            {item.order_number}
          </a>
        );
      }
      return item.order_number;
    },
  },
  distributor: { label: UserLanguage().data.distributor.label, key: "name" },
  moq: { label: UserLanguage().data.articleSource.moq },
  quantity_scale: {
    label: UserLanguage().data.quantity_scale.label,
    render: (item) =>
      _.map(item.quantity_scale, (qs, i) => (
        <div key={item.id + "_" + i}>
          {qs.quantity}: {qs.price.toFixed(4)}€
        </div>
      )),
  },
};

export const ArticleDisplay = (props: { article: Article | null }) => {
  const query = useQuery<{ article: Article }>(FullArticleQuery, {
    variables: {
      id: props.article?.id,
    },
    skip: props.article === null,
  });

  if (!props.article) return null;

  console.log("query", query.loading, query.error, query.data);

  if (query.loading) return <Spinner />;
  if (query.error || !query.data) return <div>Error: {query.error}</div>;

  const article = query.data.article;

  const rows = _.map(
    [
      `${UserLanguage().data.article.matchcode}: ${article.matchcode}`,
      `${UserLanguage().data.display_name}: ${article.display_name}`,
      `${UserLanguage().data.footprint.label}: ${article.footprint?.name}`,
      `${UserLanguage().data.location.label}: ${LocationPrettyRender(
        article.location
      )}`,
      `${UserLanguage().data.product_group.label}: ${GroupPrettyRender(
        article.product_group
      )}`,
    ],
    (i, index) => (
      <h2 key={props.article?.id + "_" + index} style={{ fontWeight: 500 }}>
        {i}
      </h2>
    )
  );

  let picture = <></>;
  if (article.picture) {
    if (article.picture.startsWith("http")) {
      picture = <img src={article.picture} width={200} height={200} alt="" />;
    } else if (article.picture.startsWith("data:image")) {
      picture = <img src={article.picture} width={200} height={200} alt="" />;
    }
  }

  return (
    <div style={{ margin: 25 }}>
      <h2>
        <Link target="_blank" rel="noreferrer" to={`/articles/${article.id}`}>
          ID: {article.id}
        </Link>
      </h2>
      {rows}
      {picture}
      <h2 style={{ marginTop: 25 }}>
        {UserLanguage().data.articleSource.label_plural}
      </h2>
      <Table<ArticleSource>
        columns={ArticleSourceListColumns}
        items={article.sources}
      />
    </div>
  );
};
